// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3pqQM","icon":"SortAdornment_icon__3_50o","up":"SortAdornment_up__3sSFG","down":"SortAdornment_down__3ro-Q","active":"SortAdornment_active__2BCDc"};